export const it = {
  profile: {
    pageTitle: 'Profilo',
    teamList: {
      goTo: 'Vedi tutti i team ({{count}})',
      manager: 'Responsabile',
      noTeamName: 'Senza nome',
      viewDetails: 'Visualizza',
    },
  },
};
